import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/Global-Services/common.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PopUpPartnerActionComponentComponent } from 'src/app/Module/Pages/pop-up-partner-action-component/pop-up-partner-action-component.component';
import { AuditTrailPopUpComponent } from 'src/app/Module/Pages/audit-trail-pop-up/audit-trail-pop-up.component';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PopUpAttachRevisedLetterComponent } from '../pop-up-attach-revised-letter/pop-up-attach-revised-letter.component';
import { PopUpReturnRecordStatusChangeComponent } from '../pop-up-return-record-status-change/pop-up-return-record-status-change.component';
import { environment } from 'src/environments/environment';

import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-ftedetails',
  templateUrl: './ftedetails.component.html',
  styleUrls: ['./ftedetails.component.css'],
  providers: [CommonService],
  standalone: false,
})

export class FTEDetailsComponent implements OnInit {
  selectedDate: Date;
  requesterList: any;
  n: any;
  ID: string = '';
  filteredEngagementSingle: any[] = [];
  EmploymentExtensionList: any[] = [];
  EmploymentExtensionListRef: any[] = [];
  ConversionCycleList: any[] = [];
  ExtensionTypeList: any[] = [];
  ExtensionTypeListRef: any[] = [];
  TenureOfRetentionByCouncelorList: any[] = [];
  TenureOfExtensionByCouncelorList: any[] = [];
  TenureOfExtensionBySLHRList: any[] = [];
  LocationMasterList: any[] = [];//Added  by Shreya CR_2303_0039
  CouncelorRecommendationList: any[] = [];
  ClosureStatusList: any[] = [];
  ClosureStatusListRef: any[] = [];
  boolReturn: any;
  ErrorMessage = [];
  formData: FormData = new FormData();
  DisplayNone: any;
  IsDisableForSLHR: boolean;
  IsDisableForFinance: boolean;
  SupportingAttachment: File;
  IsSLHR = false;
  IsCounsellor = false;
  IsPartner = false;
  Roles = [];
  DecimalPlaces = [];
  IsAdmin = false;
  validChar = true;
  IsFinanceTeam = false; //added by vedha bethi
  TenureOfExtensionByFinanceList: any[] = [];
  minDate = null;
  maxDate = null;
  minDateLID = null;//Added  by Shreya CR_2303_0039
  maxDateLID = null;//Added  by Shreya CR_2303_0039
  Engcode = null;
  EngTitle = null;
  EngCodeList: string[];
  //Added by Utkarsh for CR_2311_0209 Start
  CouncelorScopeofWorkDate: any;
  IsFinContractEndDate: boolean = true;
  minFinContractEndDate = null;
  IsConversionCycleDate: boolean = true;
  ctcPercentage: number = 0;
  incrementedCTC: number = 0;
  totalCTCNumber: number = 0;
  ProposedEndDate: string = '';
  LocalTenureOfExtensionBySLHRID: number = 0;
  LocalTenureOfExtensionBySLHRDesc: string = '';
  LocalNextContractEndDate: any;
  changesDoneBySLHR: Boolean = false;

  //Added By Akash Agrawal For CR_2501_0010
  LastWorkingDayDate: any;
  LastWorkingDayDateSLHR: any;
  minLastWorkingDate: any;
  TenureOfRetainByCouncelorIDRef: any;
  FinanceContractEndDateChanged: boolean = false;
  TenureOfExtensionBySLHRIDRef : any;
  NextContractEndDateRef: any;
  TenureOfExtensionByCouncelorIDRef: any;
  //Ended By Akash Agrawal For CR_2501_0010

  @ViewChild('txtCouncelorComment') txtCouncelorComment?: NgModel;
  @ViewChild('txtPerformance') txtPerformance?: NgModel;
  @ViewChild('txtUtilization') txtUtilization?: NgModel;
  @ViewChild('txtYearlyBilling') txtYearlyBilling?: NgModel;
  @ViewChild('txtGM') txtGM?: NgModel;
  @ViewChild('ProposedCTC') ProposedCTC?: NgModel;
  @ViewChild('txtDetaildBuinessCase') txtDetaildBuinessCase?: NgModel;
  @ViewChild('txtMonthlyBilling') txtMonthlyBilling?: NgModel;
  @ViewChild('txtRemark') txtRemark?: NgModel;
  @ViewChild('txtFinanceTeamRemarks') txtFinanceTeamRemarks?: NgModel;
  @ViewChild('txtIncrementBySLHR') txtIncrementBySLHR?: NgModel;
  @ViewChild('txtNHPSrNumberBySLHR') txtNHPSrNumberBySLHR?: NgModel;
  @ViewChild('txtClosureCommentBySLHR') txtClosureCommentBySLHR?: NgModel;
  //Added by Utkarsh for CR_2311_0209 End

  @ViewChild('ProposedCTCSLHR') ProposedCTCSLHR?: NgModel;         //Added by Akash Agrawal for CR_2501_0010

  EngagementList = {
    Engcode: '',
    EngTitle: ''
  };

  FTERecord = {
    ID: '',
    FTEID: '',
    EmpGPN: '',
    EmpLPN: '',
    EmpName: '',
    EmpEmail: '',
    EmpTitle: '',
    EmpLocation: '',
    EmpCouncelorGPN: '',
    EmpCouncelorName: '',
    EmpManagerGPN: '',
    EmpManagerName: '',
    EmpPartnerGPN: '',
    EmpPartnerName: '',
    EmpJoiningDate: '',
    EmpMobile: '',
    EmpCUG: '',
    EmpLegalEntity: '',
    EmpBUDesc: '',
    EmpStatus: '',
    EmpOfficeAddress: '',
    RequestStatusID: 0,
    RequestStatusDesc: '',
    EmpContractEndDate: '',
    NewEmpContractEndDate: '',
    ConsEmpContractEndDate: '',
    LastIncrementDate: '',
    TotalCTC: '',
    TotalCTCWords: '',
    EmpAnnexure: '',
    EmploymentExtensionID: 0,
    EmploymentExtensionDesc: '',
    ConversionCycleID: 0,
    ConversionCycleDesc: '',
    ExtensionTypeID: 0,
    ExtensionTypeDesc: '',
    ExtensionTypeIDSLHR: 0,
    ExtensionTypeDescSLHR: '',
    TenureOfExtensionByCouncelorID: 0,
    TenureOfExtensionByCouncelorDesc: '',
    TenureOfRetainByCouncelorID: 0,
    TenureOfRetainByCouncelorDesc: '',
    CouncelorRecommendationID: 0,
    CouncelorRecommendationDesc: '',
    CouncelorScopeofWork: '',
    IncrementInPercentByCouncelor: 0,
    CouncelorComment: '',
    DetaildBuinessCase: '', //Added by akram on 09-Dec-2020
    Utilization: 0, //Added by akram on 09-Dec-2020
    Performance: '', //Added by akram on 09-Dec-2020
    MonthlyBilling: 0, //Added by akram on 09-Dec-2020
    YearlyBilling: 0, //Added by akram on 09-Dec-2020
    GM: 0, //Added by akram on 09-Dec-2020
    Remark: '', //Added by akram on 09-Dec-2020
    CutOfDate1: '', //Added by akram on 09-Dec-2020
    IsRecordCretedAfterCutOfDate: false, //Added by akram on 09-Dec-2020
    CreatedOn: '',
    PartnerActionBy: '',
    PartnerActionOn: '',
    PartnerComments: '',
    SLHRReturnComments: '',
    CouncelorActionOn: '',
    CouncelorActionBy: '',
    ClosureStatusID: 0,
    ClosureStatusDesc: '',
    TenureOfExtensionBySLHRID: 0,
    TenureOfExtensionBySLHRDesc: '',
    IncrementInPercentBySLHR: 0,
    ClosureComments: '',
    SLHRActionBy: '',
    SLHRActionOn: '',
    SupportingDocumentAttachmentID: '',
    ServiceLine: '',
    ActionType: '',
    CurrUserGPN: '',
    AttachmentName: '',
    AttachmentData: null,
    AttachmentID: 0,
    AttachmentList: [],
    //added by vedha bethi on 09-jun-2021 for CR_2103_0066
    ClientEngAttachmentName: '',
    ClientEngAttachmentData: null,
    ClientEngAttachmentID: 0,
    ClientEngAttachmentList: [],
    FinanceTeamRemarks: '',
    ExtensionByFinanceTeamID: 0,
    ExtensionByFinanceTeamDesc: '',
    NextContractEndDate: '',
    NextContractEndDateSend: '',
    //end by vedha bethi on 09-jun-2021 for CR_2103_0066
    Engcode: '',
    EngTitle: '',
    ProjectLocation: '',//Added  by Shreya CR_2303_0039
    ProjectLocationID: 0,//Added  by Shreya CR_2303_0039
    //Added by Utkarsh for CR_2311_0209 Start
    EmployeeType: '',
    CompetencyName: '',
    ActivityType: '',
    ProposedCTC: 0,
    ProposedCTCSLHR: 0,           //Added by Akash Agrawal for CR_2501_0010
    FinContractEndDate: '',
    FinContractEndDateRef: '',    //Added by Akash Agrawal for CR_2501_0010
    NHPSrNumber: '',
    EmpMarketSegment: '',
    ConversionCycleDate: '',
    ConversionCycleDateSLHR: '',
    PartnerApprAttachmentList: [],
    PartnerApprAttachmentName: '',
    PartnerApprAttachmentData: null,
    PartnerApprAttachmentID: 0,
    IsFinContractEndDate: false,
    ConCalculationValue: 0,
    //Added by Utkarsh for CR_2311_0209 End

    //Added By Akash Agrawal For CR_2501_0010
    IsLetterGenerated: false,
    IsLetterSent: false,
    IsRevisedLetterAttached: false,
    FinanceUser: '',
    SLHRUser: '',
    LastWorkingDay: '',
    LastWorkingDaySLHR: '',
    
    CancelledRemark: '',
    ProposedContractEndDateRetain: ''
  };

  constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService,
    public gService: CommonService, public datepipe: DatePipe, private gVariable: GlobalVariable,
    private appTokenHandler: AppTokenHandler, private _Location: Location, public dialog: MatDialog, private _router: Router,
    private el: ElementRef, private dateAdapter: DateAdapter<Date>,private cd: ChangeDetectorRef) { }


  ngOnInit() {

    this.gVariable.User = this.gService.getUserDetails('zero');
    this.ID = this.route.snapshot.paramMap.get('ParamID');
    this.FTERecord.CurrUserGPN = this.gVariable.User.UserGPN;
    this.Roles = this.gVariable.User._ApplicationRole.split(',');
    this.filteredEngagementSingle = [];

    this.minLastWorkingDate = new Date();
    this.IsAdmin = this.Roles.indexOf('Admin') > -1 ? true : false;
    // this.IsCounsellor = this.Roles.indexOf('IsCounsellor') > -1 ? true : false;
    // this.IsPartner = this.Roles.indexOf('IsPartner') > -1 ? true : false;
    this.IsSLHR = this.Roles.indexOf('IsSLHR') > -1 ? true : false;
    this.GetKeyWordByKeyWordType('EmploymentExtension');
    this.GetKeyWordByKeyWordType('ExtensionType');
    this.GetKeyWordByKeyWordType('ConversionCycle');
    this.GetKeyWordByKeyWordType('TenureOfExtensionByCouncelor');
    this.GetKeyWordByKeyWordType('TenureOfExtensionBySLHR');
    this.GetKeyWordByKeyWordType('TenureOfRetentionByCouncelor');
    this.GetKeyWordByKeyWordType('CouncelorRecommendation');
    this.GetKeyWordByKeyWordType('ClosureStatus');
    this.GetKeyWordByKeyWordType('ExtensionByFinanceTeam');//added by vedha bethi on 21        -jun-2021 for CR_2103_0066

    this.CheckUserIsFinanceTeam(this.gVariable.User.UserGPN);//added by vedha bethi on 15-jun-2021 for CR_2103_0066

    if (this.ID != null && this.ID !== '') {
      this.GetFTEDetailsByID(this.ID, this.FTERecord.CurrUserGPN);
    } else {
      this.GetKeyWordByKeyWordType('LocationMaster'); //Added by Utkarsh for CR_2311_0209
    }

  }

  SetTextValue(event, Type: any): void {
    const newVal = event.target.value;

    if (Type == "EmploymentExtension") {
      this.FTERecord.EmploymentExtensionDesc = event.target.options[event.target.selectedIndex].text;
      this.FTERecord.TenureOfExtensionByCouncelorID = 0;
      this.FTERecord.TenureOfRetainByCouncelorID = 0;
      this.FTERecord.CouncelorScopeofWork = '';
      this.FTERecord.CouncelorRecommendationID = 0;
      this.FTERecord.IncrementInPercentByCouncelor = 0;
      this.FTERecord.CouncelorComment = '';
      this.FTERecord.ConversionCycleID = 0;
      this.LastWorkingDayDate = '';
      this.FTERecord.LastWorkingDay = '';

      if((this.FTERecord.EmploymentExtensionID == 1 || this.FTERecord.EmploymentExtensionID == 4)  && this.FTERecord.EmpBUDesc == 'GPS' )
      {
        this.ExtensionTypeList = this.ExtensionTypeList.filter(r => (r.KeyWordValue !== '1'));
      }
      else
      {
        this.ExtensionTypeList = this.ExtensionTypeListRef;
      }
      this.FTERecord.ProposedContractEndDateRetain = '';
    }
    else if (Type == "TenureOfExtensionByCouncelor") {
      this.FTERecord.TenureOfExtensionByCouncelorDesc = event.target.options[event.target.selectedIndex].text;
      const matchingItem = this.TenureOfExtensionByCouncelorList.find(item =>
        item.KeyWordValue == this.FTERecord.TenureOfExtensionByCouncelorID
      );
      if (matchingItem) {
        this.FTERecord.ConCalculationValue = matchingItem.CalculationValue;
      }

      if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("1")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("3");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("2")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("6");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("3")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("12");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("4")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("24");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("5")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("1");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("6")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("2");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("7")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("4");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("8")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("5");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("9")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("7");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("10")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("8");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("11")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("9");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("12")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("10");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("13")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("11");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("14")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("13");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("15")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("14");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("16")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("15");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("17")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("16");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("18")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("17");
      }
       else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("19")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("18");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("20")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("19");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("21")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("20");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("22")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("21");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("23")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("22");
      }
      else if (this.FTERecord.TenureOfExtensionByCouncelorID == Number.parseInt("24")) {
        this.TenureOfExtensionByCouncelorIDRef = Number.parseInt("23");
      }
      else {
        this.TenureOfExtensionByCouncelorIDRef = this.FTERecord.TenureOfRetainByCouncelorID;
      }

      var d = moment(this.FTERecord.EmpContractEndDate);  //Added by Utkarsh for CR_2311_0209
      this.ProposedEndDate = d.add(this.FTERecord.ConCalculationValue, 'month').toISOString();  //Added by Utkarsh for CR_2311_0209

    }
    else if (Type == "TenureOfRetainByCouncelor") {
      this.FTERecord.TenureOfRetainByCouncelorDesc = event.target.options[event.target.selectedIndex].text;

      if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("1")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("6");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("2")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("12");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("3")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("1");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("4")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("2");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("5")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("3");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("6")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("4");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("7")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("5");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("8")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("7");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("9")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("8");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("10")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("9");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("11")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("10");
      }
      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("12")) {
        this.TenureOfRetainByCouncelorIDRef = Number.parseInt("11");
      }
      else {
        this.TenureOfRetainByCouncelorIDRef = this.FTERecord.TenureOfRetainByCouncelorID;
      }
      //Added By Akash Agrawal
      if (this.FTERecord.ConversionCycleDate != null && this.FTERecord.ConversionCycleDate != '') {
        var d = moment(this.FTERecord.ConversionCycleDate);
        this.FTERecord.ProposedContractEndDateRetain = d.add(this.TenureOfRetainByCouncelorIDRef, 'month').toISOString();
      }

    }
    else if (Type == "Recommendation") {
      this.FTERecord.CouncelorRecommendationDesc = event.target.options[event.target.selectedIndex].text;
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.CouncelorRecommendationID == Number.parseInt("1") && this.FTERecord.ExtensionTypeID == Number.parseInt("1")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("0");
      // }
      // else if (this.FTERecord.CouncelorRecommendationID == Number.parseInt("2") && this.FTERecord.ExtensionTypeID == Number.parseInt("1")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("8");
      // }
      // else if (this.FTERecord.CouncelorRecommendationID == Number.parseInt("3") && this.FTERecord.ExtensionTypeID == Number.parseInt("1")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("10");
      // }
      // else if (this.FTERecord.CouncelorRecommendationID == Number.parseInt("4") && this.FTERecord.ExtensionTypeID == Number.parseInt("1")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("12");
      // }
      // else if (this.FTERecord.ExtensionTypeID == Number.parseInt("2")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("0");
      // }
    }
    else if (Type == "ClosureStatusBySLHR") {
      this.FTERecord.LastWorkingDaySLHR = '';
      this.LastWorkingDayDateSLHR = '',
      this.FTERecord.ConversionCycleDateSLHR = '';
      this.FTERecord.ClosureStatusDesc = event.target.options[event.target.selectedIndex].text;
      if(this.FTERecord.ClosureStatusID == 4)
      {
        this.FTERecord.TenureOfExtensionBySLHRID = this.TenureOfExtensionBySLHRIDRef;
        this.FTERecord.NextContractEndDate = this.NextContractEndDateRef;
        this.FTERecord.NextContractEndDateSend = this.NextContractEndDateRef;
      }
      else if(this.FTERecord.ClosureStatusID == 1)
      {
        this.FTERecord.TenureOfExtensionBySLHRID = this.TenureOfRetainByCouncelorIDRef;
        this.FTERecord.NextContractEndDate = this.NextContractEndDateRef;
        this.FTERecord.NextContractEndDateSend = this.NextContractEndDateRef;
      }
      else{
      this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("0");
      this.FTERecord.NextContractEndDate = '';
      this.FTERecord.NextContractEndDateSend = '';
      }
      if((this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4) && this.FTERecord.EmpBUDesc == 'GPS' )
      {
        this.ExtensionTypeList = this.ExtensionTypeList.filter(r => (r.KeyWordValue !== '1'));
      }
      else
      {
        this.ExtensionTypeList = this.ExtensionTypeListRef;
      }
      if(this.FTERecord.ClosureStatusID == 2 || this.FTERecord.ClosureStatusID == 3)
      {
        this.FTERecord.IncrementInPercentBySLHR = Number.parseInt("0");
        this.FTERecord.ProposedCTCSLHR = null;
        this.FTERecord.ExtensionTypeIDSLHR = null;
        this.FTERecord.ExtensionTypeDescSLHR = '';
      }
      else
      {
        this.FTERecord.ProposedCTCSLHR = this.FTERecord.ProposedCTC;
        this.FTERecord.ExtensionTypeIDSLHR = this.FTERecord.ExtensionTypeID;
        this.FTERecord.ExtensionTypeDescSLHR = this.FTERecord.ExtensionTypeDesc;
        this.OnProposedCTCChange("change");
      }
      this.FTERecord.ClosureComments = '';
      this.FTERecord.NHPSrNumber = '';
      if(this.FTERecord.IsLetterGenerated == true)
      {
        this.changesDoneBySLHR = true
      }
    }
    else if (Type == "TenureOfExtensionBySLHR") {  //Modified by Utkarsh for CR_2311_0209
      let slhr = this.FTERecord.TenureOfExtensionBySLHRID.toString();
      let councelor = this.FTERecord.ConCalculationValue.toString();
    //    if (this.FTERecord.ClosureStatusID == 4) {
    //   var d = moment(this.FTERecord.ConversionCycleDate);
    //   this.FTERecord.NextContractEndDate = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
    //   this.FTERecord.NextContractEndDateSend = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
    // }
      if (slhr != councelor && slhr != '' && councelor != '') {
        if (confirm("You are making the changes in 'Tenure of Extension' which are not recommended by Counsellor and FMA. Do you want to continue?")) {
          this.FTERecord.TenureOfExtensionBySLHRDesc = event.target.options[event.target.selectedIndex].text;

          if (this.FTERecord.ClosureStatusID == 4) {
            var d = moment(this.FTERecord.ConversionCycleDate);
            this.FTERecord.NextContractEndDate = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
            this.FTERecord.NextContractEndDateSend = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
          }
          else {
            var d = moment(this.FTERecord.EmpContractEndDate);
            this.FTERecord.NextContractEndDate = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
            this.FTERecord.NextContractEndDateSend = d.add(1, 'day').toISOString();
          }

          var pastDate = new Date(this.FTERecord.NextContractEndDate);
          pastDate.setDate(pastDate.getDate() - 15);
          this.minDate = pastDate;

          var futureDate = new Date(this.FTERecord.NextContractEndDate);
          futureDate.setDate(futureDate.getDate() + 15);
          this.maxDate = futureDate;
        }
        else {
          event.target.value = this.LocalTenureOfExtensionBySLHRID;
          event.target.options[event.target.selectedIndex].text = this.LocalTenureOfExtensionBySLHRDesc;
          this.FTERecord.TenureOfExtensionBySLHRID = this.LocalTenureOfExtensionBySLHRID;
          this.FTERecord.TenureOfExtensionBySLHRDesc = this.LocalTenureOfExtensionBySLHRDesc;
          this.FTERecord.NextContractEndDate = this.LocalNextContractEndDate;
          this.FTERecord.NextContractEndDateSend = this.LocalNextContractEndDate;

          var pastDate = new Date(this.FTERecord.NextContractEndDate);
          pastDate.setDate(pastDate.getDate() - 15);
          this.minDate = pastDate;

          var futureDate = new Date(this.FTERecord.NextContractEndDate);
          futureDate.setDate(futureDate.getDate() + 15);
          this.maxDate = futureDate;
        }
      } else if (slhr == councelor && slhr != '' && councelor != '') {
        this.FTERecord.TenureOfExtensionBySLHRDesc = event.target.options[event.target.selectedIndex].text;

        var d = moment(this.FTERecord.EmpContractEndDate);
        this.FTERecord.NextContractEndDate = d.add(this.FTERecord.TenureOfExtensionBySLHRID, 'month').toISOString();
        this.FTERecord.NextContractEndDateSend = d.add(1, 'day').toISOString();

        var pastDate = new Date(this.FTERecord.NextContractEndDate);
        pastDate.setDate(pastDate.getDate() - 15);
        this.minDate = pastDate;

        var futureDate = new Date(this.FTERecord.NextContractEndDate);
        futureDate.setDate(futureDate.getDate() + 15);
        this.maxDate = futureDate;
      }
      if(this.FTERecord.IsLetterGenerated == true)
      {
        this.changesDoneBySLHR = true
      }
    }
    else if (Type == "ConversionCycle") {
      this.FTERecord.ConversionCycleDesc = event.target.options[event.target.selectedIndex].text;
    }
    else if (Type == "ExtensionType") {
      this.FTERecord.ExtensionTypeDesc = event.target.options[event.target.selectedIndex].text;
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.ExtensionTypeID == Number.parseInt("2")) {
      //   this.FTERecord.IncrementInPercentByCouncelor = Number.parseInt("0");
      // }

      if(this.FTERecord.ExtensionTypeID == 2)
      {
        this.FTERecord.ProposedCTC = this.totalCTCNumber;
      }
    }
    //added by vedha bethi on 12-jun-2021 for CR_2103_0066
    else if (Type == "ExtensionByFinanceTeam") {
      this.FTERecord.ExtensionByFinanceTeamDesc = event.target.options[event.target.selectedIndex].text;
    }
    //end by vedha
    else if (Type == "ProjectLocation") {
      this.FTERecord.ProjectLocation = event.target.options[event.target.selectedIndex].text;
    }
    //Added By Akash Agrawal For CR_2501_0010
    else if (Type == "ExtensionTypeSLHR") {
      this.FTERecord.ExtensionTypeDescSLHR = event.target.options[event.target.selectedIndex].text;
      if(this.FTERecord.ExtensionTypeIDSLHR == 2)
      {
        this.FTERecord.ProposedCTCSLHR = this.totalCTCNumber;;
        this.OnProposedCTCChange("change");
        
      }
      else
      {
        this.FTERecord.ProposedCTCSLHR = this.FTERecord.ProposedCTC;
        this.OnProposedCTCChange("change");
      }
      if(this.FTERecord.IsLetterGenerated == true)
      {
        this.changesDoneBySLHR = true;
      }
    }
    //Ended By Akash Agrawal For CR_2501_0010
    this.cd.detectChanges();
  }

  GetEngagementSearch(event: any) {
    this.EngCodeList = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEngagementSearch(query.trim(), this.FTERecord.EmpGPN).subscribe((data: any) => {
        if (data != null && data.length > 0) {
          this.EngCodeList = [];
          this.EngCodeList = data;
          this.filteredEngagementSingle = this.filterFilterEngagement(query, this.EngCodeList);
          console.log(this.filteredEngagementSingle);
        } else {
          this.EngCodeList = [];
          this.filteredEngagementSingle = [];
          alert('Please search correct engagement code.');
          this.Engcode = '';
        }
      },
        (err: HttpErrorResponse) => {
          this.EngCodeList = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  filterFilterEngagement(query: any, EngList: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < EngList.length; i++) {
      const Engagement = EngList[i];
      if (Engagement.Engcode.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
        filtered.push(Engagement);
      }
    }
    return filtered;
  }

  SetSelectedEngagement(event: any) {
    this.FTERecord.Engcode = event.value.Engcode;
    this.FTERecord.EngTitle = event.value.EngTitle;
  }

  GetFTEDetailsByID(ID: any, CurrUserGPN: string) {
    this.gService.GetFTEDetailsByID(ID, CurrUserGPN).subscribe((data: any) => {

      if (data != null) {
        this.FTERecord.ID = data.ID;
        this.FTERecord.FTEID = data.FTEID;
        this.FTERecord.EmpLPN = data.EmpLPN;//Added  by Shreya CR_2303_0039
        this.FTERecord.EmpGPN = data.EmpGPN;
        this.FTERecord.EmpName = data.EmpName;
        this.FTERecord.EmpEmail = data.EmpEmail;
        this.FTERecord.EmpTitle = data.EmpTitle;
        this.FTERecord.EmpLocation = data.EmpLocation;
        this.FTERecord.EmpCouncelorGPN = data.EmpCouncelorGPN;
        this.FTERecord.EmpCouncelorName = data.EmpCouncelorName;
        this.FTERecord.EmpManagerGPN = data.EmpManagerGPN;
        this.FTERecord.EmpManagerName = data.EmpManagerName;
        this.FTERecord.EmpPartnerGPN = data.EmpPartnerGPN;
        this.FTERecord.EmpPartnerName = data.EmpPartnerName;
        this.FTERecord.EmpJoiningDate = data.EmpJoiningDate;
        this.FTERecord.EmpMobile = data.EmpMobile;
        this.FTERecord.EmpCUG = data.EmpCUG;
        this.FTERecord.EmpLegalEntity = data.EmpLegalEntity;
        this.FTERecord.EmpBUDesc = data.EmpBUDesc;
        this.FTERecord.EmpStatus = data.EmpStatus;
        this.FTERecord.EmpOfficeAddress = data.EmpOfficeAddress;
        this.FTERecord.RequestStatusID = data.RequestStatusID;
        this.FTERecord.RequestStatusDesc = data.RequestStatusDesc;
        this.FTERecord.EmpContractEndDate = data.EmpContractEndDate;
        this.FTERecord.NewEmpContractEndDate = data.NewEmpContractEndDate;
        this.FTERecord.ConsEmpContractEndDate = data.ConsEmpContractEndDate;
        this.FTERecord.LastIncrementDate = data.LastIncrementDate;
        if(data.EmpCouncelorGPN == this.FTERecord.CurrUserGPN)
        {
          this.IsCounsellor = true;
        }
        else if(data.EmpPartnerGPN == this.FTERecord.CurrUserGPN)
        {
          this.IsPartner = true;
        }
        var pastDate = new Date(this.FTERecord.NextContractEndDate);
        pastDate.setDate(pastDate.getDate() - 15);
        this.minDateLID = pastDate;

        var futureDate = new Date(this.FTERecord.NextContractEndDate);
        futureDate.setDate(futureDate.getDate() + 15);
        this.maxDateLID = futureDate;

        var empContractEndDate = new Date(this.FTERecord.EmpContractEndDate);
        empContractEndDate.setDate(empContractEndDate.getDate() + 90);
        this.minFinContractEndDate = empContractEndDate;

        this.FTERecord.TotalCTC = data.TotalCTC;
        this.totalCTCNumber = parseInt(data.TotalCTC);
        this.FTERecord.EmploymentExtensionID = data.EmploymentExtensionID;
        this.FTERecord.EmploymentExtensionDesc = data.EmploymentExtensionDesc;
        if (this.FTERecord.EmploymentExtensionID == 0) {
          this.FTERecord.ExtensionTypeID = Number.parseInt("2");
        }
        else {
          this.FTERecord.ExtensionTypeID = data.ExtensionTypeID;
        }

        if ((this.FTERecord.EmploymentExtensionID == 1 || this.FTERecord.EmploymentExtensionID == 4) && this.FTERecord.EmpBUDesc == 'GPS') {
          this.ExtensionTypeList = this.ExtensionTypeList.filter(r => (r.KeyWordValue !== '1'));
        }


        this.FTERecord.ExtensionTypeDesc = data.ExtensionTypeDesc;
        this.FTERecord.ConversionCycleDesc = data.ConversionCycleDesc;
        this.FTERecord.ConversionCycleID = data.ConversionCycleID;
        this.FTERecord.TenureOfExtensionByCouncelorID = data.TenureOfExtensionByCouncelorID;
        this.FTERecord.TenureOfExtensionByCouncelorDesc = data.TenureOfExtensionByCouncelorDesc;
        this.FTERecord.TenureOfRetainByCouncelorID = data.TenureOfRetainByCouncelorID;
        this.FTERecord.TenureOfRetainByCouncelorDesc = data.TenureOfRetainByCouncelorDesc;
        this.FTERecord.CouncelorRecommendationID = data.CouncelorRecommendationID;
        this.FTERecord.CouncelorRecommendationDesc = data.CouncelorRecommendationDesc;
        this.FTERecord.CouncelorScopeofWork = data.CouncelorScopeofWork;
        //Added by Utkarsh for CR_2311_0209 Start
        this.FTERecord.ConCalculationValue = data.ConCalculationValue;
        if (data.CouncelorScopeofWork != null) {
          this.CouncelorScopeofWorkDate = this.ConvertStringToDate(data.CouncelorScopeofWork);
        }
        this.FTERecord.ProposedCTC = data.ProposedCTC > 0 ? data.ProposedCTC : Number.parseInt(data.TotalCTC);
         //Added by Akash Agrawal for CR_2501_0010
        this.FTERecord.ProposedCTCSLHR = data.ProposedCTCSLHR; 
        this.FTERecord.ExtensionTypeIDSLHR = data.ExtensionTypeIDSLHR;
        this.FTERecord.ExtensionTypeDescSLHR = data.ExtensionTypeDescSLHR;        
         //Ended by Akash Agrawal for CR_2501_0010
        this.FTERecord.EmpMarketSegment = data.EmpMarketSegment;
        this.FTERecord.NHPSrNumber = data.NHPSrNumber;
        if (data.ConversionCycleDate == '0001-01-01T00:00:00') {
          this.FTERecord.ConversionCycleDate = null;
        } else {
          this.FTERecord.ConversionCycleDate = data.ConversionCycleDate;
        }
        if (data.ProposedContractEndDateRetain == '0001-01-01T00:00:00') {
          this.FTERecord.ProposedContractEndDateRetain = null;
        } else {
          this.FTERecord.ProposedContractEndDateRetain = data.ProposedContractEndDateRetain;
        }
        if (data.FinContractEndDate == '0001-01-01T00:00:00') {
          this.FTERecord.FinContractEndDate = null;
          this.FTERecord.FinContractEndDateRef = null;
        } else {
          this.FTERecord.FinContractEndDate = data.FinContractEndDate;
          this.FTERecord.FinContractEndDateRef = data.FinContractEndDate;
        }
        if (data.CouncelorActionOn == '0001-01-01T00:00:00') {
          this.FTERecord.CouncelorActionOn = null;
        } else {
          this.FTERecord.CouncelorActionOn = data.CouncelorActionOn;
        }
        this.FTERecord.EmployeeType = data.EmployeeType;
        if(this.FTERecord.EmployeeType == "Retainer")
        {
          this.EmploymentExtensionList = this.EmploymentExtensionList.filter(r => (r.KeyWordValue !== '4'));
        }
        if(this.FTERecord.EmployeeType == "Retainer")
        {
          this.ClosureStatusList = this.ClosureStatusList.filter(r => (r.KeyWordValue !== '4'));
        }
        if (this.FTERecord.EmploymentExtensionID == 2 || this.FTERecord.EmploymentExtensionID == 3) {
          this.ClosureStatusList = this.ClosureStatusList.filter(r => (r.KeyWordValue !== '1'));
        }
        this.FTERecord.ActivityType = data.ActivityType;
        this.FTERecord.CompetencyName = data.CompetencyName;
        this.FTERecord.IsFinContractEndDate = data.IsFinContractEndDate;
        //Added by Utkarsh for CR_2311_0209 End
        this.FTERecord.IncrementInPercentByCouncelor = data.IncrementInPercentByCouncelor;
        this.FTERecord.CouncelorComment = data.CouncelorComment;
        this.FTERecord.CreatedOn = data.CreatedOn;
        this.FTERecord.PartnerActionBy = data.PartnerActionBy;
        if (data.PartnerActionOn == '0001-01-01T00:00:00') {
          this.FTERecord.PartnerActionOn = null;
        } else {
          this.FTERecord.PartnerActionOn = data.PartnerActionOn;
        }
        this.FTERecord.PartnerComments = data.PartnerComments;
        this.FTERecord.SLHRReturnComments = data.SLHRReturnComments;
        this.FTERecord.CouncelorActionBy = data.CouncelorActionBy;
        // Added by akram on 10-Dec-2020 - (CR_2009_0256)
        this.FTERecord.DetaildBuinessCase = data.DetaildBuinessCase;
        this.FTERecord.Utilization = data.Utilization;
        this.FTERecord.Performance = data.Performance;
        this.FTERecord.MonthlyBilling = data.MonthlyBilling;
        this.FTERecord.YearlyBilling = data.YearlyBilling;
        this.FTERecord.GM = data.GM;
        this.FTERecord.Remark = data.RequestStatusID > Number.parseInt("3") ? data.Remark : '';
        this.FTERecord.CutOfDate1 = data.CutOfDate1;
        this.FTERecord.IsRecordCretedAfterCutOfDate = data.IsRecordCretedAfterCutOfDate;
        // End By Akram on 10-Dec-2020 - (CR_2009_0256)
        this.FTERecord.ClosureStatusID = data.ClosureStatusID;
        if ((this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4) && this.FTERecord.EmpBUDesc == 'GPS') {
          this.ExtensionTypeList = this.ExtensionTypeList.filter(r => (r.KeyWordValue !== '1'));
        }

      //   if ((data.ClosureStatusID != 0 || data.ClosureStatusID != null) && (data.RequestStatusID == Number.parseInt("9") || data.RequestStatusID == Number.parseInt("3") || data.RequestStatusID == Number.parseInt("4") || data.RequestStatusID == Number.parseInt("8"))) {
      //     this.FTERecord.ClosureStatusID = data.ClosureStatusID;
      //   }
      //   else {
      //     this.FTERecord.ClosureStatusID = this.FTERecord.EmploymentExtensionID;
      //     if(this.FTERecord.ClosureStatusID == 1 && this.FTERecord.EmpMarketSegment == 'GPS' )
      // {
      //   this.ExtensionTypeList = this.ExtensionTypeList.filter(r => (r.KeyWordValue !== '1'));
      // }
      //   }
        this.FTERecord.ClosureStatusDesc = data.ClosureStatusDesc;
        this.FTERecord.TenureOfExtensionBySLHRID = data.TenureOfExtensionBySLHRID;

        // if ((data.TenureOfExtensionBySLHRID != 0 || data.TenureOfExtensionBySLHRID != null) && (data.RequestStatusID == Number.parseInt("9") || data.RequestStatusID == Number.parseInt("3") || data.RequestStatusID == Number.parseInt("4") || data.RequestStatusID == Number.parseInt("8"))) {
        //   this.FTERecord.TenureOfExtensionBySLHRID = data.TenureOfExtensionBySLHRID;
        // }
        // else {
        //   if (this.FTERecord.ConCalculationValue != 0 && this.FTERecord.ConCalculationValue != null) {
        //     this.FTERecord.TenureOfExtensionBySLHRID = data.ConCalculationValue;  //Added by Utkarsh for CR_2311_0209
        //   }
        //   else if (this.FTERecord.TenureOfRetainByCouncelorID != 0 && this.FTERecord.TenureOfRetainByCouncelorID != null) {
        //     if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("1")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("6");
        //     }
        //     else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("2")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("12");
        //     }
        //     else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("3")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("1");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("4")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("2");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("5")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("3");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("6")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("4");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("7")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("5");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("8")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("7");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("9")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("8");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("10")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("9");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("11")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("10");
        //     }
        //      else if (this.FTERecord.TenureOfRetainByCouncelorID == Number.parseInt("12")) {
        //       this.FTERecord.TenureOfExtensionBySLHRID = Number.parseInt("11");
        //     }
        //      else {
        //       this.FTERecord.TenureOfExtensionBySLHRID = this.FTERecord.TenureOfRetainByCouncelorID;
        //     }
            
          // }
          // else {
          //   this.FTERecord.TenureOfExtensionBySLHRID = 0;
          // }
        //}
        this.FTERecord.TenureOfExtensionBySLHRDesc = data.TenureOfExtensionBySLHRDesc;
        if(data.RequestStatusID == Number.parseInt("5") && this.FTERecord.ExtensionTypeIDSLHR == 1)
        {
          this.OnProposedCTCChange("NotChange");
        }
        else
        {
          this.FTERecord.IncrementInPercentBySLHR = data.IncrementInPercentBySLHR;
        }
        // if ((data.IncrementInPercentBySLHR != 0 && data.IncrementInPercentBySLHR != null) && (data.RequestStatusID == Number.parseInt("9") || data.RequestStatusID == Number.parseInt("3") || data.RequestStatusID == Number.parseInt("4") || data.RequestStatusID == Number.parseInt("8"))) {
        //   this.FTERecord.IncrementInPercentBySLHR = data.IncrementInPercentBySLHR;
        // }
        // //Added by Utkarsh for CR_2311_0209 Start
        // else if (this.FTERecord.TotalCTC != null && this.FTERecord.TotalCTC != '' && this.FTERecord.ProposedCTC != null && this.FTERecord.ProposedCTC != undefined && this.FTERecord.ExtensionTypeID == 1
        //   && (data.RequestStatusID == Number.parseInt("5") || data.RequestStatusID == Number.parseInt("6") || data.RequestStatusID == Number.parseInt("7"))
        // ) {
        //   let totalCTC = parseInt(this.FTERecord.TotalCTC);
        //   if (this.FTERecord.ProposedCTC !== 0) { // Ensure the denominator is not zero
        //     const difference = this.FTERecord.ProposedCTC - totalCTC;
        //     this.ctcPercentage = (difference / totalCTC) * 100;
        //     this.ctcPercentage = this.ctcPercentage >= 0 ? parseFloat(this.ctcPercentage.toFixed(1)) : 0; // If negative, set to zero
        //   } else {
        //     this.ctcPercentage = 0; // If denominator is zero, set percentage to zero
        //   }
        //   this.FTERecord.IncrementInPercentBySLHR = this.ctcPercentage;
        // }
        //Added by Utkarsh for CR_2311_0209 End
        //Commented By Akash Agrawal For CR_2501_0010
        // else {
        //   this.FTERecord.IncrementInPercentBySLHR = this.FTERecord.IncrementInPercentByCouncelor;
        // }
        // this.FTERecord.ClosureComments = data.RequestStatusID === Number.parseInt("9") ? data.ClosureComments : '';
        this.FTERecord.ClosureComments = data.ClosureComments;
        this.FTERecord.SLHRActionBy = data.SLHRActionBy;
        this.FTERecord.SLHRActionOn = data.SLHRActionOn;
        this.FTERecord.SupportingDocumentAttachmentID = data.SupportingDocumentAttachmentID;
        this.FTERecord.ServiceLine = data.ServiceLine;
        this.FTERecord.AttachmentList = data.AttachmentList;
        this.sortedAttachment();
        if (data.AttachmentList.length > 0) {
          this.FTERecord.AttachmentID = data.AttachmentList[0].AttachmentID
          this.FTERecord.AttachmentName = data.AttachmentList[0].AttachmentName
        }

        if (this.FTERecord.TotalCTC != null || this.FTERecord.TotalCTC != '') {
          this.NumToWords(this.FTERecord.TotalCTC);
        }
        //	added by vedha bethi on 10-jun-2021 for CR_2103_0066
        if (data.ClientEngAttachmentList.length > 0) {
          this.FTERecord.ClientEngAttachmentID = data.ClientEngAttachmentList[0].AttachmentID
          this.FTERecord.ClientEngAttachmentName = data.ClientEngAttachmentList[0].AttachmentName
        }
        //Added by Utkarsh for CR_2311_0209
        if (data.PartnerApprAttachmentList.length > 0) {
          this.FTERecord.PartnerApprAttachmentID = data.PartnerApprAttachmentList[0].AttachmentID;
          this.FTERecord.PartnerApprAttachmentName = data.PartnerApprAttachmentList[0].AttachmentName;
        }
        if (data.RequestStatusID == Number.parseInt("11")) {
          this.FTERecord.ExtensionByFinanceTeamID = data.ConCalculationValue;
          this.FTERecord.ExtensionByFinanceTeamDesc = data.TenureOfExtensionByCouncelorDesc;
        }
        else {
          this.FTERecord.ExtensionByFinanceTeamID = data.ExtensionByFinanceTeamID;
          this.FTERecord.ExtensionByFinanceTeamDesc = data.ExtensionByFinanceTeamDesc;
        }
        //Added by Utkarsh for CR_2311_0209 Start
        if (data.ExtensionByFinanceTeamID > 0 && data.ExtensionByFinanceTeamID != "" && !data.IsFinContractEndDate) {
          this.IsFinContractEndDate = false;
        }
        if (data.ConversionCycleID > 0 && data.ConversionCycleID != "") {
          this.IsConversionCycleDate = false;
        }
        var d = moment(this.FTERecord.EmpContractEndDate);
        this.ProposedEndDate = d.add(data.ConCalculationValue, 'month').toISOString();
        //Added by Utkarsh for CR_2311_0209 End
        this.FTERecord.FinanceTeamRemarks = data.RequestStatusID === Number.parseInt("11") ? '' : data.FinanceTeamRemarks;

        // if (data.RequestStatusID == Number.parseInt("5")) {
        //   if (data.ExtensionByFinanceTeamID > 0 && data.ExtensionByFinanceTeamID != "") {
        //     this.FTERecord.TenureOfExtensionBySLHRID = data.ExtensionByFinanceTeamID;
        //     this.FTERecord.TenureOfExtensionBySLHRDesc = data.ExtensionByFinanceTeamDesc;
        //   }

        // }
        if (data.NextContractEndDate == '0001-01-01T00:00:00') {
          this.FTERecord.NextContractEndDate = null;
        } else {
          this.FTERecord.NextContractEndDate = data.NextContractEndDate;
        }
        if (data.NextContractEndDate == '0001-01-01T00:00:00') {
          this.FTERecord.NextContractEndDateSend = null;
        } else {
          this.FTERecord.NextContractEndDateSend = data.NextContractEndDate;
        }
        this.LocalNextContractEndDate = this.FTERecord.NextContractEndDate;
        if(this.FTERecord.ClosureStatusID == 4)
        {
          this.TenureOfExtensionBySLHRIDRef = data.TenureOfExtensionBySLHRID;
          this.NextContractEndDateRef = this.FTERecord.NextContractEndDateSend;
        }
        if(this.FTERecord.ClosureStatusID == 1)
        {
          this.TenureOfExtensionByCouncelorIDRef = data.TenureOfExtensionBySLHRID;
          this.NextContractEndDateRef = this.FTERecord.NextContractEndDateSend;
        }

        this.LocalTenureOfExtensionBySLHRID = this.FTERecord.TenureOfExtensionBySLHRID;  //Added by Utkarsh for CR_2311_0209
        this.LocalTenureOfExtensionBySLHRDesc = this.FTERecord.TenureOfExtensionBySLHRDesc;  //Added by Utkarsh for CR_2311_0209 Start

        this.FTERecord.Engcode = data.Engcode;
        this.FTERecord.ProjectLocationID = data.ProjectLocationID;//Added  by Shreya CR_2303_0039
        this.FTERecord.ProjectLocation = data.ProjectLocation;//Added  by Shreya CR_2303_0039
        this.FTERecord.EngTitle = data.EngTitle;
        this.filteredEngagementSingle = [
          {
            Engcode: data.Engcode,
          }
        ];
        this.Engcode = this.filteredEngagementSingle[0];

        var pastDate = new Date(this.FTERecord.NextContractEndDate);
        pastDate.setDate(pastDate.getDate() - 15);
        this.minDate = pastDate;


        var futureDate = new Date(this.FTERecord.NextContractEndDate);
        futureDate.setDate(futureDate.getDate() + 15);
        this.maxDate = futureDate;

        //Added By Akash Agrawal for CR_2501_0010
        this.FTERecord.IsLetterGenerated = data.IsLetterGenerated;
         this.FTERecord.IsLetterSent = data.IsLetterSent;
         this.FTERecord.IsRevisedLetterAttached = data.IsRevisedLetterAttached;
         this.FTERecord.FinanceUser = data.FinanceUser;
         this.FTERecord.SLHRUser = data.SLHRUser;
         this.FTERecord.LastWorkingDay = data.LastWorkingDay;
         this.FTERecord.CancelledRemark = data.CancelledRemark;
         
        if(data.LastWorkingDaySLHR != null && data.LastWorkingDaySLHR != '')
        {
           this.FTERecord.LastWorkingDaySLHR = data.LastWorkingDaySLHR;
        }
        if (data.LastWorkingDay != null && data.LastWorkingDay != '') {
          this.LastWorkingDayDate = this.ConvertStringToDate(data.LastWorkingDay);
        }
        if(data.LastWorkingDaySLHR != null && data.LastWorkingDaySLHR != '')
        {
          this.LastWorkingDayDateSLHR = this.ConvertStringToDate(data.LastWorkingDaySLHR);
        }

        if(data.ConversionCycleDateSLHR != null && data.ConversionCycleDateSLHR != '')
        {
          this.FTERecord.ConversionCycleDateSLHR = data.ConversionCycleDateSLHR;
        }
        //Ended By Akash Agrawal for CR_2501_0010

        //End by vedha bethi on 10-jun-2021 for CR_2103_0066
        this.DisableFields();
        this.GetKeyWordByKeyWordType('LocationMaster', this.FTERecord.EmpGPN); //Added by Utkarsh for CR_2311_0209
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }


  NumToWords(value: any): any {

    var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (value) {
      let num: any = Number(value);
      if (num) {
        if ((num = num.toString()).length > 9) { return 'overflow'; }
        const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) { return ''; }
        let str = '';
        str += (Number(n[1]) !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
        str += (Number(n[2]) !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
        str += (Number(n[3]) !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
        str += (Number(n[4]) !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
        str += (Number(n[5]) !== 0) ? ((str !== '') ? 'and ' : '') +
          (a[Number(n[5])] || b[n[5][0]] + ' ' +
            a[n[5][1]]) + '' : '';

        if (str != null && str != '')
          str = str + ' Only';

        this.FTERecord.TotalCTCWords = str;

        value = Math.round(num);
        var result = value.toString().split('.');
        var lastThree = result[0].substring(result[0].length - 3);
        var otherNumbers = result[0].substring(0, result[0].length - 3);
        if (otherNumbers != '' && otherNumbers != '-')
          lastThree = ',' + lastThree;
        var output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

        if (result.length > 1) {
          output += "." + result[1];
        }

        this.FTERecord.TotalCTC = "₹ " + output;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  GetKeyWordByKeyWordType(Value: string, EmpGPN: string = '') {  //Modified by Utkarsh for CR_2311_0209
    this.gService.GetKeyWordByKeyWordType(Value, EmpGPN).subscribe((data: any) => {

      if (Value === 'EmploymentExtension') {
        this.EmploymentExtensionList = data;
        this.EmploymentExtensionListRef = data;
      }
      else if (Value === 'TenureOfExtensionByCouncelor') {
        this.TenureOfExtensionByCouncelorList = data;
      }
      else if (Value === 'TenureOfRetentionByCouncelor') {
        this.TenureOfRetentionByCouncelorList = data;
      }
      else if (Value === 'CouncelorRecommendation') {
        this.CouncelorRecommendationList = data;
      }
      else if (Value === 'TenureOfExtensionBySLHR') {
        this.TenureOfExtensionBySLHRList = data;
      }
      else if (Value === 'ClosureStatus') {
        this.ClosureStatusList = data;
        this.ClosureStatusListRef = data;
      }
      else if (Value === 'ConversionCycle') {
        this.ConversionCycleList = data;
      }
      else if (Value === 'ExtensionType') {
        this.ExtensionTypeList = data;
        this.ExtensionTypeListRef = data;
      }
      else if (Value === 'ExtensionByFinanceTeam') { //added by vedha bethi on 19-jun-2021
        this.TenureOfExtensionByFinanceList = data;
      }
      //Added  by Shreya CR_2303_0039
      else if (Value === 'LocationMaster') { //added by vedha bethi on 19-jun-2021
        this.LocationMasterList = data;
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit() {
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to Exit?');
    if (this.boolReturn === false) {
      return;
    }
    this._Location.back();
  }

  UpdateCouncelorAction() {
    this.ErrorMessage = [];

    if (this.FTERecord.EmploymentExtensionID == null || this.FTERecord.EmploymentExtensionID <= 0) {
      this.ErrorMessage.push({ message: 'Please select Employment Extension.' });
    }
    if (this.txtPerformance && this.txtPerformance.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Performance.' });
    }
    if (this.ProposedCTC && this.ProposedCTC.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Proposed CTC.' });
    }
    if (this.txtRemark && this.txtRemark.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Remarks/Any additional inputs.' });
    }
    //Added  by Shreya CR_2303_0039
    if(this.FTERecord.EmploymentExtensionID != 2)
    {
    if (this.FTERecord.ProjectLocationID == null || this.FTERecord.ProjectLocationID <= 0) {
      this.ErrorMessage.push({ message: 'Please select Project Location.' });
    }
  }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("1")) {
      if (this.FTERecord.TenureOfExtensionByCouncelorID == null || this.FTERecord.TenureOfExtensionByCouncelorID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Feedback.' });
      }
      if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.IncrementInPercentByCouncelor == null || this.FTERecord.IncrementInPercentByCouncelor < Number.parseFloat("0")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentByCouncelor > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
      //Added by akram on 15-Jan-2020 - For UAT Changes
      if (this.FTERecord.CouncelorScopeofWork == null || this.FTERecord.CouncelorScopeofWork == '') {
        this.ErrorMessage.push({ message: 'Please enter client engagement end date.' });
      }
      //Added by akram on 10-Dec-2020 (CR_2009_0256)
      if ((this.txtDetaildBuinessCase && this.txtDetaildBuinessCase.invalid) || (this.FTERecord.DetaildBuinessCase == null || this.FTERecord.DetaildBuinessCase == '')) {
        this.ErrorMessage.push({ message: 'Please enter Detailed of Business.' });
      }
      if ((this.txtUtilization && this.txtUtilization.invalid) || (this.FTERecord.EmpMarketSegment == 'GPS' && (this.FTERecord.Utilization == null || this.FTERecord.Utilization <= 0))) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter Utilization.' });
      }
      if ((this.txtMonthlyBilling && this.txtMonthlyBilling.invalid) || (this.FTERecord.EmpMarketSegment == 'GPS' && (this.FTERecord.MonthlyBilling == null || this.FTERecord.MonthlyBilling <= 0))) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter Monthly Billing.' });
      }
      if ((this.txtYearlyBilling && this.txtYearlyBilling.invalid) || (this.FTERecord.EmpMarketSegment == 'GPS' && (this.FTERecord.YearlyBilling == null || this.FTERecord.YearlyBilling <= 0))) {
        this.ErrorMessage.push({ message: 'Please enter Yearly Billing.' });
      }
      if ((this.txtGM && this.txtGM.invalid) || (this.FTERecord.EmpMarketSegment == 'GPS' && (this.FTERecord.GM == null || this.FTERecord.GM <= 0))) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter GM.' });
      }
       if ((this.txtPerformance && this.txtPerformance.invalid) || (this.FTERecord.EmpMarketSegment == 'GPS' && (this.FTERecord.Performance == null || this.FTERecord.Performance == ''))) {  //Modified by Akash Agrawal for CR_2501_0010
        this.ErrorMessage.push({ message: 'Please enter performance.' });
      }
      if (this.FTERecord.EmpMarketSegment == 'GPS' && this.FTERecord.Utilization > 100) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Utilization value should be less than or equal to 100.' });
      }
      if (this.FTERecord.EmpMarketSegment == 'GPS' && this.FTERecord.GM > 100) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'GM value should be less than or equal to 100.' });
      }
      //End By Akram on 10-Dec-2020 (CR_2009_0256)
      if (this.FTERecord.EmpMarketSegment == 'NonGPS' && (this.FTERecord.ServiceLine == 'Tax' || this.FTERecord.ServiceLine == 'Forensics' || this.FTERecord.ServiceLine == 'Assurance') && this.FTERecord.PartnerApprAttachmentList.length == 0) {  //Added by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please upload Partner Approval.' });
      }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("2")) {
      //Commented by Akash Agrawal for CR_2501_0010
      // if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
      //   this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      // }
      // if (this.FTERecord.EmpMarketSegment == 'NonGPS' && this.FTERecord.ServiceLine == 'Tax' && this.FTERecord.PartnerApprAttachmentList.length == 0) {  //Added by Utkarsh for CR_2311_0209
      //   this.ErrorMessage.push({ message: 'Please upload Partner Approval.' });
      // }

      // /this.FTERecord.EmpMarketSegment == 'NonGPS' && (this.FTERecord.ServiceLine == 'Tax' || this.FTERecord.ServiceLine == 'Forensics' || this.FTERecord.ServiceLine == 'Assurance') && Commented by Akash Agrawal for CR_2501_0010
       if ( this.FTERecord.PartnerApprAttachmentList.length == 0) {  //Added by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please upload Partner Approval.' });
      }

      if ( this.FTERecord.LastWorkingDay == null || this.FTERecord.LastWorkingDay == '') {  //Added by Akash Agrawal for CR_2501_0010
        this.ErrorMessage.push({ message: 'Please select Last Working Day.' });
      }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("3")) {
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
      //   this.ErrorMessage.push({ message: 'Please select Feedback.' });
      // }
      if (this.IsConversionCycleDate) {  //Modified by Utkarsh for CR_2311_0209
        if (this.FTERecord.ConversionCycleDate == null || this.FTERecord.ConversionCycleDate == '') {
          this.ErrorMessage.push({ message: 'Please select Conversion Cycle Date.' });
        }
      } else {
        if (this.FTERecord.ConversionCycleID == null || this.FTERecord.ConversionCycleID <= 0) {
          this.ErrorMessage.push({ message: 'Please select Conversion Cycle.' });
        }
      }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
       //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
      //   this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      // }
      if (this.FTERecord.PartnerApprAttachmentList.length == 0) {  //Added by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please upload Partner Approval.' });
      }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("4")) {
      if (this.FTERecord.TenureOfRetainByCouncelorID == null || this.FTERecord.TenureOfRetainByCouncelorID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Retain.' });
      }
      if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Feedback.' });
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.IncrementInPercentByCouncelor == null || this.FTERecord.IncrementInPercentByCouncelor < Number.parseFloat("0")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentByCouncelor > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
      if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      }
      if (this.FTERecord.EmpMarketSegment == 'NonGPS' && (this.FTERecord.ServiceLine == 'Tax' || this.FTERecord.ServiceLine == 'Forensics' || this.FTERecord.ServiceLine == 'Assurance') && this.FTERecord.PartnerApprAttachmentList.length == 0) {  //Added by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please upload Partner Approval.' });
      }
    }
    if (this.validChar == false) {
      this.validChar = true;
      this.ErrorMessage.push({ message: 'Invalid character found.' });
    }

    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;
    if (this.ErrorMessage.length > 0) {
      return;
    }

    if(this.FTERecord.ExtensionTypeID == 1 && this.FTERecord.ProposedCTC == this.totalCTCNumber)
    {
      alert("Please select the without increment option, as there is no change in the CTC value entered by you.");
      return;
    }
    
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to submit this renewal form?');
    if (this.boolReturn === false) {
      return;
    }

    this.FTERecord.ProposedCTCSLHR = this.FTERecord.ProposedCTC;
    this.FTERecord.ExtensionTypeDescSLHR = this.FTERecord.ExtensionTypeDesc;
    this.FTERecord.ExtensionTypeIDSLHR = this.FTERecord.ExtensionTypeID;
    this.FTERecord.ClosureStatusID = this.FTERecord.EmploymentExtensionID;
    this.FTERecord.ClosureStatusDesc = this.FTERecord.EmploymentExtensionDesc
    if(this.LastWorkingDayDate != '' && this.LastWorkingDayDate != null)
    this.LastWorkingDayDateSLHR = this.LastWorkingDayDate; 
    if(this.FTERecord.LastWorkingDay != '' && this.FTERecord.LastWorkingDay != null)
    this.FTERecord.LastWorkingDaySLHR = this.FTERecord.LastWorkingDay;
    if(this.FTERecord.ConversionCycleDate != '' && this.FTERecord.ConversionCycleDate != null)
    this.FTERecord.ConversionCycleDateSLHR = this.FTERecord.ConversionCycleDate;
    this.OnProposedCTCChange("change");
    if(this.FTERecord.EmploymentExtensionID == 4)
    {
      this.FTERecord.NextContractEndDateSend = this.FTERecord.ProposedContractEndDateRetain;
      this.FTERecord.TenureOfExtensionBySLHRID = this.TenureOfRetainByCouncelorIDRef;
    }
    if(this.FTERecord.EmploymentExtensionID == 1)
    {
      this.FTERecord.TenureOfExtensionBySLHRID = this.TenureOfExtensionByCouncelorIDRef;
      this.FTERecord.NextContractEndDateSend = this.FTERecord.ProposedContractEndDateRetain;
    }
    this.gService.PostService(this.FTERecord, 'FTEDetails/UpdateCouncelorAction').subscribe(data => {
      if(data != null && data != "" && data.toLowerCase() != "success")
      {
        alert(data);
        return;
      }
      alert("Data Submitted Successfully!");
      this._router.navigate(['/View/ViewPendingForRenewal/1']);
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  OpenDialog(Action: any) {
    this.ErrorMessage = [];

    if(Action == 'Approve')
    {
    if (this.FTERecord.EmploymentExtensionID == null || this.FTERecord.EmploymentExtensionID <= 0) {
      this.ErrorMessage.push({ message: 'Please select Employment Extension.' });
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("1")) {
      if (this.FTERecord.TenureOfExtensionByCouncelorID == null || this.FTERecord.TenureOfExtensionByCouncelorID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Feedback.' });
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.IncrementInPercentByCouncelor == null || this.FTERecord.IncrementInPercentByCouncelor < Number.parseFloat("0")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentByCouncelor > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
      if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      }
      //Added by akram on 15-Jan-2020 - For UAT Changes for Mandatory only
      if (this.FTERecord.CouncelorScopeofWork == null || this.FTERecord.CouncelorScopeofWork == '') {
        this.ErrorMessage.push({ message: 'Please enter client engagement end date.' });
      }
      //Added by akram on 10-Dec-2020 (CR_2009_0256)
      if ((this.txtDetaildBuinessCase && this.txtDetaildBuinessCase.invalid) || ((this.FTERecord.DetaildBuinessCase == null || this.FTERecord.DetaildBuinessCase == '') && this.FTERecord.IsRecordCretedAfterCutOfDate == true)) {
        this.ErrorMessage.push({ message: 'Please enter Detaild of Business.' });
      }
      if ((this.txtUtilization && this.txtUtilization.invalid) || ((this.FTERecord.Utilization == null || this.FTERecord.Utilization <= 0) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS')) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter Utilization.' });
      }
      if ((this.txtMonthlyBilling && this.txtMonthlyBilling.invalid) || ((this.FTERecord.MonthlyBilling == null || this.FTERecord.MonthlyBilling <= 0) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS')) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter Monthly Billing.' });
      }
      if ((this.txtYearlyBilling && this.txtYearlyBilling.invalid) || ((this.FTERecord.YearlyBilling == null || this.FTERecord.YearlyBilling <= 0) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS')) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter Yearly Billing.' });
      }

      // added by vedha bethi on 05-july-2021

      if ((this.FTERecord.MonthlyBilling != null && this.FTERecord.MonthlyBilling < 10000) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS') {  //Modified by Utkarsh for CR_2311_0209

        this.ErrorMessage.push({ message: 'Monthly Billing cannot be less than 10000.' });
      }
      if ((this.FTERecord.YearlyBilling != null && this.FTERecord.YearlyBilling < 100000) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS') {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Yearly Billing cannot be less than 100000.' });
      }
      //end by vedha

      if ((this.txtGM && this.txtGM.invalid) || ((this.FTERecord.GM == null || this.FTERecord.GM <= 0) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS')) {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Please enter GM.' });
      }
      if ((this.FTERecord.Utilization > 100) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS') {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'Utilization value should be less than or equal to 100.' });
      }
      if ((this.FTERecord.GM > 100) && this.FTERecord.IsRecordCretedAfterCutOfDate == true && this.FTERecord.EmpMarketSegment == 'GPS') {  //Modified by Utkarsh for CR_2311_0209
        this.ErrorMessage.push({ message: 'GM value should be less than or equal to 100.' });
      }
      //End By Akram on 10-Dec-2020 (CR_2009_0256)
    }
    // if (this.FTERecord.EmploymentExtensionID == Number.parseInt("2")) {
    //   if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
    //     this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
    //   }
    // }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("3")) {
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
      //   this.ErrorMessage.push({ message: 'Please select Feedback.' });
      // }
      if (this.IsConversionCycleDate) {  //Modified by Utkarsh for CR_2311_0209
        if (this.FTERecord.ConversionCycleDate == null || this.FTERecord.ConversionCycleDate == '') {
          this.ErrorMessage.push({ message: 'Please select Conversion Cycle Date.' });
        }
      } else {
        if (this.FTERecord.ConversionCycleID == null || this.FTERecord.ConversionCycleID <= 0) {
          this.ErrorMessage.push({ message: 'Please select Conversion Cycle.' });
        }
      }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
      //   this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      // }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("4")) {
      if (this.FTERecord.TenureOfRetainByCouncelorID == null || this.FTERecord.TenureOfRetainByCouncelorID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Retain.' });
      }
      if (this.FTERecord.CouncelorRecommendationID == null || this.FTERecord.CouncelorRecommendationID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Feedback.' });
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // if (this.FTERecord.IncrementInPercentByCouncelor == null || this.FTERecord.IncrementInPercentByCouncelor < Number.parseFloat("0")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentByCouncelor > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      if ((this.txtCouncelorComment && this.txtCouncelorComment.invalid) || this.FTERecord.CouncelorComment == null || this.FTERecord.CouncelorComment == '') {
        this.ErrorMessage.push({ message: 'Please enter valid Client engagement deployed on.' });
      }
      if (this.FTERecord.ExtensionTypeID == null || this.FTERecord.ExtensionTypeID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Extension Type.' });
      }
    }
  }

    if (this.validChar == false) {
      this.validChar = true;
      this.ErrorMessage.push({ message: 'Invalid character found.' });
    }

    if (this.ErrorMessage.length > 0) {
      return;
    }

    this.boolReturn = false;

    if (Action == 'Approve') {
      this.FTERecord.ActionType = 'Approve';
      this.boolReturn = confirm('Are you sure you want to Approve?');
    }
    if (Action == 'Return') {
      this.FTERecord.ActionType = 'Return';
      this.boolReturn = confirm('Are you sure you want to Return?');
    }
    if (Action == 'Reject') {
      this.FTERecord.ActionType = 'Reject';
      this.boolReturn = confirm('Are you sure you want to Reject?');
    }

    if (this.boolReturn === false) {
      return;
    }
    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;
    const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
    const dialogRef = this.dialog.open(PopUpPartnerActionComponentComponent,
      {
        width: '60%',
        maxWidth: '80vw',
        data: { FTERecord: this.FTERecord, CurrUserGPN: this.FTERecord.CurrUserGPN, IsAdmin: this.IsAdmin, IsPartner: this.IsPartner, IsSLHR: this.IsSLHR }
      });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  
  OpenAuditTrailDialog() {
    const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
    const dialogRef = this.dialog.open(AuditTrailPopUpComponent,
      {
        width: '85%',
        maxWidth: '95%',
        data: { ID: this.FTERecord.ID, ClassName: 'INFTE' },
        ariaLabel: 'Audit Trail'
      });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  async UpdateSLHRAction(type: string) {
    this.ErrorMessage = [];
    if (this.FTERecord.ClosureStatusID == null || this.FTERecord.ClosureStatusID <= 0) {
      this.ErrorMessage.push({ message: 'Please select Closure Status.' });
    }
    if (this.txtClosureCommentBySLHR && this.txtClosureCommentBySLHR.invalid) {
      this.ErrorMessage.push({ message: 'Please select valid Closure Comments.' });
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("1")) {
      if ((this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) &&  (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      if (this.changesDoneBySLHR == true && type != "SendMail" && (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)) {
        alert("Please generate the letter first.")
        return;
      }
      
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      //Commented By Akash Agrawal For CR_2501_0010
      // else if (this.FTERecord.IncrementInPercentBySLHR > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      // if (this.FTERecord.ClosureComments == null || this.FTERecord.ClosureComments == '') {  //Modified by Utkarsh for CR_2311_0209
      //   this.ErrorMessage.push({ message: 'Please enter Closure Comments.' });
      // }
    }
    // if (this.FTERecord.EmploymentExtensionID == Number.parseInt("2")) {
    //   if (this.FTERecord.ClosureComments == null || this.FTERecord.ClosureComments == '') {  //Modified by Utkarsh for CR_2311_0209
    //     this.ErrorMessage.push({ message: 'Please enter Closure Comments.' });
    //   }
    // }
    // if (this.FTERecord.EmploymentExtensionID == Number.parseInt("3")) {
    //   if (this.FTERecord.ClosureComments == null || this.FTERecord.ClosureComments == '') {   //Modified by Utkarsh for CR_2311_0209
    //     this.ErrorMessage.push({ message: 'Please enter Closure Comments.' });
    //   }
    // }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("4")) {
      if ((this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) &&  (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
       //Commented By Akash Agrawal For CR_2501_0010
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentBySLHR > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
      // if (this.FTERecord.ClosureComments == null || this.FTERecord.ClosureComments == '') {  //Modified by Utkarsh for CR_2311_0209
      //   this.ErrorMessage.push({ message: 'Please enter Closure Comments.' });
      // }
    }
    if (this.FTERecord.ClosureStatusID == 3 || this.FTERecord.ClosureStatusID == 4) { //Added by Utkarsh for CR_2311_0209
      if ((this.txtNHPSrNumberBySLHR && this.txtNHPSrNumberBySLHR.invalid) || (this.FTERecord.NHPSrNumber == null || this.FTERecord.NHPSrNumber == ''))
        this.ErrorMessage.push({ message: 'Please enter valid NHP SR number.' });
    }

    if (this.FTERecord.ClosureStatusID == 3) {   //Added by Akash for CR_2311_0209
      if (this.FTERecord.ConversionCycleDateSLHR == null || this.FTERecord.ConversionCycleDateSLHR == '') {
          this.ErrorMessage.push({ message: 'Please select Conversion Cycle Date.' });
        }
    }

    if (this.FTERecord.ClosureStatusID == 2) { //Added by Akash for CR_2311_0209
      if ( this.FTERecord.LastWorkingDaySLHR == null || this.FTERecord.LastWorkingDaySLHR == '') {  //Added by Akash Agrawal for CR_2501_0010
        this.ErrorMessage.push({ message: 'Please select Last Working Day.' });
      }
    }

    if (this.validChar == false) {
      this.validChar = true;
      this.ErrorMessage.push({ message: 'Invalid character found.' });
    }

    if (this.ErrorMessage.length > 0) {
      return "Not Success"; 
    }

    if((this.FTERecord.EmploymentExtensionID == 1 || this.FTERecord.EmploymentExtensionID == 4 || this.FTERecord.EmploymentExtensionID == 0) && (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4 || this.FTERecord.ClosureStatusID == 0))
    {
    if(this.FTERecord.ExtensionTypeIDSLHR == 1 && this.FTERecord.ProposedCTCSLHR == this.totalCTCNumber)
      {
        alert("Please select the without increment option, as there is no change in the CTC value entered by you.");
        return "Not Success";
      }
    }

    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to close this renewal form?');
    if (this.boolReturn === false) {
      return "Not Success";
    }

    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;


    if (this.FTERecord.NextContractEndDate === this.FTERecord.NextContractEndDateSend) {
      this.FTERecord.NextContractEndDate = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDate === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : this.FTERecord.NextContractEndDate;
      this.FTERecord.NextContractEndDateSend = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDateSend === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : (this.FTERecord.NextContractEndDateSend);
    }
    else {
      var d = moment(this.FTERecord.NextContractEndDate);
      this.FTERecord.NextContractEndDateSend = d.add(1, 'day').toISOString();

      this.FTERecord.NextContractEndDate = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDate === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : this.FTERecord.NextContractEndDate;
      this.FTERecord.NextContractEndDateSend = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDateSend === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : (this.FTERecord.NextContractEndDateSend);
    }
    if(this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)
    {
      var result = await this.ValidateContractEndDate(this.FTERecord.NextContractEndDateSend);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        return "Not Success";
      }
    }
    const data: any = await this.gService.PostService(this.FTERecord, 'FTEDetails/UpdateSLHRAction').toPromise();
    try{
      if(data != null && data != "" && data.toLowerCase() != "success")
        {
          alert(data);
          return "Not Success";
        }
        alert("Data Submitted Successfully!");
        if(this.FTERecord.ClosureStatusID == Number.parseInt("2"))
        {
          window.open(environment.exitPortalURL, '_blank');
        }
        if(type == "Update")
        this.GetFTEDetailsByID(this.ID, this.FTERecord.CurrUserGPN);
        // location.reload();
      //this._router.navigate(['/View/ViewPendingForEnd/3']);
      //alert(this.ID);
      // this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      // this._router.onSameUrlNavigation = 'reload';
      // this._router.navigate(['/View/FTEDetails'], { queryParamsHandling: 'preserve' });
    }
       catch (error) {
        this.gService.GetRestItems('Master/LogError?httpException=' + error).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
       }
  }

  async SendMail() {
    if(this.changesDoneBySLHR == true)
    {
      alert("Please generate the letter first.")
      return;
    }
    var result = await this.UpdateSLHRAction("SendMail");
    if(result == "Not Success")
      return;
    this.gService.PostService(this.FTERecord, 'FTEDetails/SendMail').subscribe(data => {
      alert("Mail Sent Successfully!");
      this.GetFTEDetailsByID(this.ID, this.FTERecord.CurrUserGPN);
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  UploadAttachment(event) {

    let type = "SupportingDocument";
    this.FTERecord.AttachmentList = [];
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.FTERecord.AttachmentList.push({ 'AttachmentName': file.name, 'AttachmentID': 0, 'IsDeleted': false });
      this.FTERecord.AttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'png' || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'msg') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 5 mb.');
          this.FTERecord.AttachmentList = [];
          this.FTERecord.AttachmentName = '';
          this.FTERecord.AttachmentID = 0;

          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.formData.append('Type', file, type);

        this.gService.UploadAttachment(this.formData, 'FTEDetails/UploadAttachment').subscribe(data => {

        });
      } else {
        alert('Please upload pdf/jpeg/png/msg file.');
        this.formData = null;
        this.FTERecord.AttachmentList = [];
        this.FTERecord.AttachmentName = '';
        this.FTERecord.AttachmentID = 0;
      }
    }
  }


  AttachmentList: any[];
  sortedAttachment() {
    this.FTERecord.AttachmentList = [];
    this.AttachmentList = this.FTERecord.AttachmentList.filter(function (item) {
      return (item.IsDeleted == false);
    });
  }

  GetAttachmentbyAttachmentID(ID, type: string) {
    this.gService.Download('FTEDetails/GetAttachmentbyAttachmentID?ID=' + ID).subscribe((data: any) => {
      const blob = new Blob([data], { type: 'application/octet-stream' });
      if (type == 'ClientEngagementLetter')
        FileSaver.saveAs(blob, this.FTERecord.ClientEngAttachmentName);
      else if (type == 'PartnerApproval')
        FileSaver.saveAs(blob, this.FTERecord.PartnerApprAttachmentName);
      else
        FileSaver.saveAs(blob, this.FTERecord.AttachmentName);
    });
  }

  DeleteUploadedFile() {

    let boolReturnConfirm = false;
    boolReturnConfirm = confirm('Are you sure you want to delete');
    if (boolReturnConfirm === false) {
      return;
    }

    if (this.FTERecord.ID != null || this.FTERecord.AttachmentList.length > 0) {
      this.gService.PostService({ FileName: this.FTERecord.AttachmentName },
        'FTEDetails/DeleteUploadedFile').subscribe(data => {

          if (data === 'Success') {
            this.FTERecord.AttachmentList = [];
            this.FTERecord.AttachmentName = '';
            this.FTERecord.AttachmentID = 0;
          }
        },
          (err: HttpErrorResponse) => {
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this._router.navigate(['/error/2']);
          });
    } else {
      this.FTERecord.AttachmentList = [];
      this.FTERecord.AttachmentName = '';
      this.FTERecord.AttachmentID = 0;
    }
  }

  DeletePartnerApprUploadedFile() {

    let boolReturnConfirm = false;
    boolReturnConfirm = confirm('Are you sure you want to delete');
    if (boolReturnConfirm === false) {
      return;
    }

    if (this.FTERecord.ID != null || this.FTERecord.PartnerApprAttachmentList.length > 0) {
      this.gService.PostService({ FileName: this.FTERecord.PartnerApprAttachmentName },
        'FTEDetails/DeleteUploadedFile').subscribe(data => {

          if (data === 'Success') {
            this.FTERecord.PartnerApprAttachmentList = [];
            this.FTERecord.PartnerApprAttachmentName = '';
            this.FTERecord.PartnerApprAttachmentID = 0;
          }
        },
          (err: HttpErrorResponse) => {
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this._router.navigate(['/error/2']);
          });
    } else {
      this.FTERecord.PartnerApprAttachmentList = [];
      this.FTERecord.PartnerApprAttachmentName = '';
      this.FTERecord.PartnerApprAttachmentID = 0;
    }
  }

  async GenerateLetter(ButtonType: string) {

    debugger;
    this.ErrorMessage = [];

    if(this.FTERecord.IsRevisedLetterAttached == true)
    {
       let boolReturnConfirm = false;
       boolReturnConfirm = confirm('Are you sure want to delete the attached letter.');
       if (boolReturnConfirm === false) {
      return;
    }
    }
    if(this.FTERecord.RequestStatusID == 5)
    {
      var output = await this.UpdateSLHRActionOnGenerateLetter();
      if(output == "Not Success")
      return;
    }

    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("1")) {
      if (this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentBySLHR > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("4")) {
      if (this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
      // else if (this.FTERecord.IncrementInPercentBySLHR > Number.parseFloat("25")) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %) between 0 to 25.' });
      // }
    }
    if (this.validChar == false) {
      this.validChar = true;
      this.ErrorMessage.push({ message: 'Invalid character found.' });
    }

    if (this.ErrorMessage.length > 0) {
      return;
    }
    alert('Please remember to send revised letter to the employee'); //Added by Utkarsh for CR_2311_0209
    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;
    //Modified by Utkarsh for CR_2311_0209
    this.requesterList = {
      ID: this.FTERecord.ID, IncrementInPercentBySLHR: this.FTERecord.IncrementInPercentBySLHR, UserGPN: this.FTERecord.CurrUserGPN,
      TenureOfExtensionBySLHRID: this.FTERecord.TenureOfExtensionBySLHRID, IsSaved: true, IsReport: true, type: "", EmployeeType: this.FTERecord.EmployeeType
      ,IsLetterGenerated : this.FTERecord.IsLetterGenerated, ButtonType: ButtonType, FTEID: this.FTERecord.FTEID, IsLetterSent : this.FTERecord.IsLetterSent
    };
    this.gService.PostDownload('ReportExport/GenerateLetter', this.requesterList).subscribe(data => {
      const blob = new Blob([data], { type: 'application/pdf' });
      FileSaver.saveAs(blob, this.FTERecord.FTEID + ".pdf");
      alert("Letter has been generated");
      this.changesDoneBySLHR = false;
      if(this.FTERecord.IsRevisedLetterAttached == true)
    {
       alert("Attached letter is deleted");
    }
      this.GetFTEDetailsByID(this.ID, this.FTERecord.CurrUserGPN);
    },
    );
  }

  DisableFields() {
    if (this.FTERecord.RequestStatusID == Number.parseInt("6") || this.FTERecord.RequestStatusID == Number.parseInt("7") || this.FTERecord.RequestStatusID == Number.parseInt("9") || this.FTERecord.RequestStatusID == Number.parseInt("5") || this.FTERecord.RequestStatusID == Number.parseInt("4") || this.FTERecord.RequestStatusID == Number.parseInt("11")) {
      this.IsDisableForSLHR = true;
    }
    if (this.FTERecord.RequestStatusID == Number.parseInt("6") || this.FTERecord.RequestStatusID == Number.parseInt("7") || this.FTERecord.RequestStatusID == Number.parseInt("9") || this.FTERecord.RequestStatusID == Number.parseInt("5") || this.FTERecord.RequestStatusID == Number.parseInt("4")) {
      this.IsDisableForFinance = true;
    }
  }

  AllowOnlyDecimalNumbers(event: KeyboardEvent) {
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37
      || event.keyCode == 39 || event.keyCode == 190) {
      return true;
    }
    else if (event.keyCode < 48 || event.keyCode > 57) {
      return false;
    }
    else {
      return true;
    }
  }

  Validate(event: any, type: any) {


    if (event.target.value.indexOf('.') > -1) {
      if (type == 'IncrementBySLHR') {
        this.DecimalPlaces = event.target.value.split('.');
        if (this.DecimalPlaces[1].length != 0 && this.DecimalPlaces[1].length > 1) {
          alert("Digits after decimal points cannot be more than one places.");
          this.FTERecord.IncrementInPercentBySLHR = Number.parseFloat("0");
        }
      }
      //Commented By Akash Agrawal For CR_2501_0010
      // else if (type == 'IncrementByCouncelor') {
      //   this.DecimalPlaces = event.target.value.split('.');
      //   if (this.DecimalPlaces[1].length != 0 && this.DecimalPlaces[1].length > 1) {
      //     alert("Digits after decimal points cannot be more than one places.")
      //     this.FTERecord.IncrementInPercentByCouncelor = Number.parseFloat("0");
      //   }
      // }
    }
    else if (type == 'IncrementBySLHR') {
      // if (event.target.value > Number.parseFloat("20")) {
      //   alert("Increment (in %) cannot be greater than 20");
      //   this.FTERecord.IncrementInPercentBySLHR = Number.parseFloat("0");
      // }
      if (event.target.value && this.FTERecord.TotalCTC != null && this.FTERecord.TotalCTC != '') {  //Added by Utkarsh for CR_2311_0209
        const incrementAmount = (this.totalCTCNumber * parseFloat(event.target.value)) / 100;
        const newCTC = this.totalCTCNumber + incrementAmount;
        this.incrementedCTC = Math.ceil(newCTC);
        this.FTERecord.ProposedCTC = this.incrementedCTC;
      }
    }
    // else if (type == 'IncrementByCouncelor') {
    //   if (event.target.value > Number.parseFloat("12")) {
    //     alert("Increment (in %) cannot be greater than 12")
    //   }
    // }
    // ******** added by vedha bethi on 09-jun-2021 for CR_2103_0066 *************
    else if (type == 'MonthlyBillingMinValueChk') {
      if (event.target.value < Number.parseFloat("10000")) {
        alert("Monthly Billing cannot be less than 10000")
        this.FTERecord.MonthlyBilling = 0;
      }
    }
    else if (type == 'YearlyBillingMinValueChk') {
      if (event.target.value < Number.parseFloat("100000")) {
        alert("Yearly Billing cannot be less than 100000")
        this.FTERecord.YearlyBilling = 0;
      }
    }

    // *********** End by vedha bethi on 09-jun-2021 for CR_2103_0066 **********
    else {
      return true;
    }
  }


  DisableSpecialCharacters(event: any) {
    //
    if (event.currentTarget.value.indexOf('--') > -1) {
      this.validChar = false;
    }
    else if (event.keyCode == Number.parseFloat('42') || event.keyCode == Number.parseFloat('39')) {
      alert("Invalid character found.");
      return false;
    }
  }
  //Added by akram on 12-Dec-2020
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  //End By AKram on 12-Dec-2020


  //  added by vedha bethi on 09-jun-2021 for CR_2103_0066
  UploadClientEngLetter(event) {

    let type = "UploadClientEngLetter";

    this.FTERecord.ClientEngAttachmentList = [];
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 8;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.FTERecord.ClientEngAttachmentList.push({ 'AttachmentName': file.name, 'AttachmentID': 0, 'IsDeleted': false, 'AttachmentFor': 'ClientEngagementLetter' });
      this.FTERecord.ClientEngAttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'png' || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'msg' || fileExtension.toLowerCase() === 'eml' || fileExtension.toLowerCase() === 'doc' || fileExtension.toLowerCase() === 'zip') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 8 mb.');
          this.FTERecord.ClientEngAttachmentList = [];
          this.FTERecord.ClientEngAttachmentName = '';
          this.FTERecord.ClientEngAttachmentID = 0;
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.formData.append('Type', file, type);

        this.gService.UploadAttachment(this.formData, 'FTEDetails/UploadClientEngLetter').subscribe(data => {

        });
      } else {
        alert('Please upload pdf/jpeg/png/msg/doc/zip/eml file.');
        this.formData = null;
        this.FTERecord.ClientEngAttachmentList = [];
        this.FTERecord.ClientEngAttachmentName = '';
        this.FTERecord.ClientEngAttachmentID = 0;
      }
    }
  }

  UploadPartnerApproval(event) {  //Added by Utkarsh for CR_2311_0209
    let type = "PartnerApproval";
    this.FTERecord.PartnerApprAttachmentList = [];
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.FTERecord.PartnerApprAttachmentList.push({ 'AttachmentName': file.name, 'AttachmentID': 0, 'IsDeleted': false, 'AttachmentFor': 'PartnerApproval' });
      this.FTERecord.PartnerApprAttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'png' || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'msg') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 5 mb.');
          this.FTERecord.PartnerApprAttachmentList = [];
          this.FTERecord.PartnerApprAttachmentName = '';
          this.FTERecord.PartnerApprAttachmentID = 0;
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.formData.append('Type', file, type);

        this.gService.UploadAttachment(this.formData, 'FTEDetails/UploadAttachment').subscribe(data => {

        });
      } else {
        alert('Please upload pdf/jpeg/png/msg file.');
        this.formData = null;
        this.FTERecord.PartnerApprAttachmentList = [];
        this.FTERecord.PartnerApprAttachmentName = '';
        this.FTERecord.PartnerApprAttachmentID = 0;
      }
    }
  }

  DeleteClientEngLetter() {
    let boolReturnConfirm = false;
    boolReturnConfirm = confirm('Are you sure you want to delete');
    if (boolReturnConfirm === false) {
      return;
    }

    if (this.FTERecord.ID != null || this.FTERecord.ClientEngAttachmentList.length > 0) {
      this.gService.PostService({ FileName: this.FTERecord.ClientEngAttachmentName },
        'FTEDetails/DeleteUploadedFile').subscribe(data => {

          if (data === 'Success') {
            this.FTERecord.ClientEngAttachmentList = [];
            this.FTERecord.ClientEngAttachmentName = '';
            this.FTERecord.ClientEngAttachmentID = 0;
          }
        },
          (err: HttpErrorResponse) => {
            this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this._router.navigate(['/error/2']);
          });
    } else {
      this.FTERecord.ClientEngAttachmentList = [];
      this.FTERecord.ClientEngAttachmentName = '';
      this.FTERecord.ClientEngAttachmentID = 0;
    }
  }

  async ActionByFinanceTeam(Action: any) {

    this.ErrorMessage = [];
    this.boolReturn = false;

    if (Action == 'Approve') {
      //Modified by Utkarsh for CR_2311_0209
      if ((this.txtFinanceTeamRemarks && this.txtFinanceTeamRemarks.invalid) || (this.FTERecord.FinanceTeamRemarks == null || this.FTERecord.FinanceTeamRemarks == '')) {
        this.ErrorMessage.push({ message: 'Please enter Remarks.' });
      }
      if (this.IsFinContractEndDate) {  //Modified by Utkarsh for CR_2311_0209
        if (this.FTERecord.FinContractEndDate == null || this.FTERecord.FinContractEndDate == '') {
          this.ErrorMessage.push({ message: 'Please select Contract end date.' });
        }
      } else {
        if (this.FTERecord.ExtensionByFinanceTeamID == null || this.FTERecord.ExtensionByFinanceTeamID <= 0) {
          this.ErrorMessage.push({ message: 'Please select Extension.' });
        }
      }
      if (this.ErrorMessage.length > 0) {
        return;
      }

    }

     var d = moment(this.FTERecord.FinContractEndDate);
     this.FTERecord.FinContractEndDateRef = d.add(1, 'day').toISOString();

    if (Action == 'Approve') {
      this.FTERecord.ActionType = 'Approve';
      this.boolReturn = confirm('Are you sure you want to Approve?');
    }
    if (Action == 'Return') {
      this.FTERecord.ActionType = 'Return';
      this.boolReturn = confirm('Are you sure you want to Return?');
    }
    if (this.boolReturn === false) {
      return;
    }

    if(this.FinanceContractEndDateChanged == true)
    {
      this.FinanceContractEndDateChanged = false;
      var result = await this.ValidateContractEndDate(this.FTERecord.FinContractEndDateRef);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        return;
      }
    }


    this.gService.PostService(this.FTERecord, 'FTEDetails/UpdateFinanceTeamAction').subscribe(data => {
      if(data != null && data != "" && data.toLowerCase() != "success")
        {
          alert(data);
          return;
        }
      alert("Data Submitted Successfully!");
      this._router.navigate(['/View/ViewPendingForRenewal/5']);
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });

  }

  OnClearEngagement() {
    this.EngagementList.Engcode = null;
    this.Engcode = null;
    this.FTERecord.Engcode = null;
    this.FTERecord.EngTitle = null;
  }

  CheckUserIsFinanceTeam(Value: any) {
    this.gService.PostService({ userGPN: Value }, 'FTEDetails/CheckUserIsFinanceTeam').subscribe((data: any) => {
      if (data != null && data.length > 0) {
        this.IsFinanceTeam = true;
      }
      else {
        this.IsFinanceTeam = false;
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }
  // end by vedha bethi on 09-jun-2021 for CR_2103_0066
  //Added by Utkarsh for CR_2311_0209 Start
  CouncelorScopeofWorkChange(event: MatDatepickerInputEvent<Date>) {
    let formattedDate = this.datepipe.transform(event.value, 'dd/MM/yyyy');
    this.FTERecord.CouncelorScopeofWork = formattedDate.toString();
  }

  //Added By Akash Agrawal For CR_2501_0010
  async LastWorkingDayDateChange(event: MatDatepickerInputEvent<Date>) {
    let formattedDate = this.datepipe.transform(event.value, 'dd/MM/yyyy');
    this.FTERecord.LastWorkingDay = formattedDate.toString();

    var result = await this.ValidateContractEndDate(this.FTERecord.LastWorkingDay);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        this.FTERecord.LastWorkingDay = '';
        this.LastWorkingDayDate = '';
      }
  }

  async LastWorkingDayDateChangeSLHR(event: MatDatepickerInputEvent<Date>) {
    let formattedDate = this.datepipe.transform(event.value, 'dd/MM/yyyy');
    this.FTERecord.LastWorkingDaySLHR = formattedDate.toString();

    var result = await this.ValidateContractEndDate(this.FTERecord.LastWorkingDaySLHR);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        this.FTERecord.LastWorkingDaySLHR = '';
        this.LastWorkingDayDateSLHR = '';
      }
      
  }
  //Ended By Akash Agrawal For CR_2501_0010


  OnlyFirstOfMonthFilter(d: Date): boolean {

    if(d !=null)
    return d.getDate() === 1;
  }
  async ChangeDateFormat(event: MatDatepickerInputEvent<Date>) {
    const d = event.value; // Get the Date object from the event
    // Format the date as "YYYY-MM-DDT00:00:00"
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1 to get the correct month
    const day = d.getDate().toString().padStart(2, '0');
    const conversionCycleDate = `${year}-${month}-${day}T00:00:00`;
    this.FTERecord.ConversionCycleDate = conversionCycleDate;

    var result = await this.ValidateContractEndDate(this.FTERecord.ConversionCycleDate);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        this.FTERecord.ConversionCycleDate = '';
      }

    //Added By Akash Agrawal
    if (this.TenureOfRetainByCouncelorIDRef != null && this.TenureOfRetainByCouncelorIDRef != 0) {
      var d1 = moment(this.FTERecord.ConversionCycleDate);
      this.FTERecord.ProposedContractEndDateRetain = d1.add(this.TenureOfRetainByCouncelorIDRef, 'month').toISOString();
    }

  }

  async ChangeDateFormatSLHR(event: MatDatepickerInputEvent<Date>) {
    const d = event.value; // Get the Date object from the event
    // Format the date as "YYYY-MM-DDT00:00:00"
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1 to get the correct month
    const day = d.getDate().toString().padStart(2, '0');
    const conversionCycleDateSLHR = `${year}-${month}-${day}T00:00:00`;
    this.FTERecord.ConversionCycleDateSLHR = conversionCycleDateSLHR;

    var result = await this.ValidateContractEndDate(this.FTERecord.ConversionCycleDateSLHR);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        this.FTERecord.ConversionCycleDateSLHR = '';
      }
  }

  ConvertStringToDate(dateString: string): Date | null {
    // Split the string into parts
    const parts = dateString.split('/');
    // Check if the dateString has the correct format
    if (parts.length === 3) {
      // Rearrange the date parts to MM/dd/yyyy format
      const formattedDateString = `${parts[1]}/${parts[0]}/${parts[2]}`;
      // Create a new Date object
      const date = new Date(formattedDateString);
      // Check if the date is valid
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    // Return null if the date is invalid or the format is incorrect
    return null;
  }
  blockSpecialChar(event: any) {
    try {
      let k;

      if (event.key !== undefined) {
        k = event.key.charCodeAt(0);
      } else {
        document.all ? k = event.keyCode : k = event.which;
      }
      return ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 45);
    }
    catch (error) {
      console.log(error);
      return;
    }
  }
  //Added by Utkarsh for CR_2311_0209 End

  //Added By Akash Agrawal for CR_2501_0010
  PreviewLetter()
  {
    const param = {
    'ID': this.FTERecord.ID,
    'Type': "LetterGenerated",
    }
    this.gService.PostDownload('FTEDetails/GetAttachmentbyAttachmentFor', param).subscribe(data => {
      const blob = new Blob([data], { type: 'application/pdf' });
      // FileSaver.saveAs(blob, this.FTERecord.FTEID + ".pdf");
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    },
    );
  }

  AttachRevisedLetter()
  {
    const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
    const dialogRef = this.dialog.open(PopUpAttachRevisedLetterComponent,
      {
        width: '60%',
        maxWidth: '80vw',
        data: { FTERecord: this.FTERecord, CurrUserGPN: this.FTERecord.CurrUserGPN }
      });
    dialogRef.afterClosed().subscribe(result => {

    });

  }

  ActionBySLHRORAdmin()
  {
     const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
    const dialogRef = this.dialog.open(PopUpReturnRecordStatusChangeComponent,
      {
        width: '60%',
        maxWidth: '80vw',
        data: { FTERecord: this.FTERecord, CurrUserGPN: this.FTERecord.CurrUserGPN }
      });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  //Ended By Akash Agrawal for CR_2501_0010

  //Added by Akash Agrawal for CR_2501_0010
  OnProposedCTCChange(type: any)
  {
    let num = (((this.FTERecord.ProposedCTCSLHR - this.totalCTCNumber) / this.totalCTCNumber) * 100).toFixed(2);
    this.FTERecord.IncrementInPercentBySLHR = Number.parseFloat(num);
    if (this.FTERecord.IsLetterGenerated == true && type == "change") {
      this.changesDoneBySLHR = true;
    }
  }
  //Ended by Akash Agrawal for CR_2501_0010


  async UpdateSLHRActionOnGenerateLetter() {
    this.ErrorMessage = [];
    if (this.FTERecord.ClosureStatusID == null || this.FTERecord.ClosureStatusID <= 0) {
      this.ErrorMessage.push({ message: 'Please select Closure Status.' });
    }
    if (this.txtClosureCommentBySLHR && this.txtClosureCommentBySLHR.invalid) {
      this.ErrorMessage.push({ message: 'Please select valid Closure Comments.' });
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("1")) {
      if ((this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) && (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
    }
    if (this.FTERecord.EmploymentExtensionID == Number.parseInt("4")) {
      if ((this.FTERecord.TenureOfExtensionBySLHRID == null || this.FTERecord.TenureOfExtensionBySLHRID <= 0) && (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)) {
        this.ErrorMessage.push({ message: 'Please select Tenure of Extension.' });
      }
      // if ((this.txtIncrementBySLHR && this.txtIncrementBySLHR.invalid) || (this.FTERecord.IncrementInPercentBySLHR == null || this.FTERecord.IncrementInPercentBySLHR < Number.parseFloat("0"))) {
      //   this.ErrorMessage.push({ message: 'Please enter Increment (in %).' });
      // }
    }
    if (this.FTERecord.ClosureStatusID == 3 || this.FTERecord.ClosureStatusID == 4) { //Added by Utkarsh for CR_2311_0209
      if ((this.txtNHPSrNumberBySLHR && this.txtNHPSrNumberBySLHR.invalid) || (this.FTERecord.NHPSrNumber == null || this.FTERecord.NHPSrNumber == ''))
        this.ErrorMessage.push({ message: 'Please enter valid NHP SR number.' });
    }
    if (this.validChar == false) {
      this.validChar = true;
      this.ErrorMessage.push({ message: 'Invalid character found.' });
    }

    if (this.ErrorMessage.length > 0) {
      return "Not Success";
    }

    this.FTERecord.CurrUserGPN = this.FTERecord.CurrUserGPN == null ? this.gVariable.User.UserGPN : this.FTERecord.CurrUserGPN;


    if (this.FTERecord.NextContractEndDate === this.FTERecord.NextContractEndDateSend) {
      this.FTERecord.NextContractEndDate = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDate === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : this.FTERecord.NextContractEndDate;
      this.FTERecord.NextContractEndDateSend = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDateSend === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : (this.FTERecord.NextContractEndDateSend);
    }
    else {
      var d = moment(this.FTERecord.NextContractEndDate);
      this.FTERecord.NextContractEndDateSend = d.add(1, 'day').toISOString();

      this.FTERecord.NextContractEndDate = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDate === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : this.FTERecord.NextContractEndDate;
      this.FTERecord.NextContractEndDateSend = this.FTERecord.RequestStatusID === 5 && (this.FTERecord.NextContractEndDateSend === '0001-01-01T00:00:00') ? '1900-01-01T00:00:00' : (this.FTERecord.NextContractEndDateSend);
    }
     if(this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4)
    {
      var result = await this.ValidateContractEndDate(this.FTERecord.NextContractEndDateSend);
      if(result.IsValidContractEndDate == 'exist')
      {
        alert("Please select valid contract end date as date selected is weekend or public holiday");
        return "Not Success";
      }
    }
    if((this.FTERecord.EmploymentExtensionID == 1 || this.FTERecord.EmploymentExtensionID == 4 || this.FTERecord.EmploymentExtensionID == 0) && (this.FTERecord.ClosureStatusID == 1 || this.FTERecord.ClosureStatusID == 4 || this.FTERecord.ClosureStatusID == 0))
    {
    if(this.FTERecord.ExtensionTypeIDSLHR == 1 && this.FTERecord.ProposedCTCSLHR == this.totalCTCNumber)
      {
        alert("Please select the without increment option, as there is no change in the CTC value entered by you.");
        return "Not Success";
      }
    }

    const data: any = await this.gService.PostService(this.FTERecord, 'FTEDetails/UpdateSLHRActionOnGenerateLetter').toPromise();
      try{
      if(data != null && data != "" && data.toLowerCase() != "success")
        {
          alert(data);
          return "Not Success";
        }
        return "Success";
      }
        catch (error) {
          this.gService.GetRestItems('Master/LogError?httpException=' + error).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
        }
  }


  async ValidateContractEndDate(contractenddate: any)
  {
    const param = {
    'NextContractEndDate': contractenddate,
    'Location': this.FTERecord.EmpLocation,
    }

    const data: any = await this.gService.PostDataWithParam('FTEDetails/ValidateContractEndDate' , param).toPromise();
    try{
          if (data != null) {
            return data[0];
        }
      }
        catch (error) {
          this.gService.GetRestItems('Master/LogError?httpException=' + error).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
        }
  }

  OnNextContractEndDate()
  {
    if (this.FTERecord.IsLetterGenerated == true) {
      this.changesDoneBySLHR = true;
    }
  }

  OnNextContractEndDateFinance()
  {
    this.FinanceContractEndDateChanged = true;
  }
}
